import React from "react";

import { isDefined } from "@utils/helpers";

import { AutocompleteItem } from "@components/Search/SearchAutocomplete/AutocompleteItem/autocompleteItem.container";
import Highlight from "@components/Search/SearchAutocomplete/Highlight/highlight.component";
import { BaseItemProps } from "@components/Search/SearchAutocomplete/ResultsPanel/resultsPanel.templates";
import { QuerySuggestionsSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";

import { getRedirectUrlFromState } from "../helpers/redirect.helpers";

type AutocompleteSuggestionsProps = BaseItemProps<QuerySuggestionsSourceType>;

const QuerySuggestionsItem = ({
    item,
    autocompleteState,
    autocompleteActions,
}: AutocompleteSuggestionsProps) => (
    <AutocompleteItem<QuerySuggestionsSourceType>
        query={item.query}
        className={"d-flex rounded"}
        itemId={item.__autocomplete_id}
        autocompleteState={autocompleteState}
        autocompleteActions={autocompleteActions}
        getRedirectUrl={() =>
            isDefined(autocompleteState)
                ? getRedirectUrlFromState(autocompleteState)
                : undefined
        }
    >
        <div>
            <i className="las la-search pr-2"></i>
        </div>
        <Highlight
            highlightMatch={item._highlightResult.query}
            reverseHighlight={true}
        />
    </AutocompleteItem>
);

export { QuerySuggestionsItem };
